import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {

    baseUrl = `${baseUrl}/pais`

    return {
        index(queryParms = {}) {

            return repository.get(`${baseUrl}?${urlUtil.serialize(queryParms)}`)
        },
        show(id) {

            return repository.get(`${baseUrl}/${id}`)
        },
    }
}